/**
 * File navigation.js.
 */
(function() {
	var navMegaLinks = document.querySelectorAll('.nav-link-mega');
	var menuShade = document.querySelector('.menu-shade');
	var hamburger = document.querySelector('.hamburger');
	var navMenuWrap = document.querySelector('.mobile-nav-menu');
	var navMenu = document.querySelector('.nav-menu');
	var body = document.body;

	hamburger.onclick = function(event) {
		event.preventDefault();

		hamburger.classList.toggle('open');

		if (hamburger.classList.contains('open')) {
			menuShade.classList.add('open-mobile');
			navMenuWrap.classList.add('open-mobile');
			body.classList.add('mobile-menu-open');

			window.scrollTo({
				top: 0,
				behavior: 'smooth'
			});
		} else {
			menuShade.classList.remove('open-mobile');
			navMenuWrap.classList.remove('open-mobile');
			body.classList.remove('mobile-menu-open');
		}
	}

	document.onclick = function(event) {
		if (!hasParentClass(event.target, 'nav-item')) {
			closeMegaNavLinks();
		}
	};

	[].forEach.call(navMegaLinks, function(navLink) {
		navLink.onclick = function(event) {
			event.preventDefault();
			var parent = event.target.parentNode;
			closeMegaNavLinks(parent);

			parent.classList.toggle('nav-item-open');
			
			if (parent.classList.contains('nav-item-open')) {
				menuShade.classList.add('open-desktop');
			}

			if (navMenu.scrollTo) {
				navMenu.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			}
		}
	});

	function closeMegaNavLinks(notClose) {
		menuShade.classList.remove('open-desktop');

		[].forEach.call(navMegaLinks, function(navLink) {
			if (notClose !== navLink.parentNode) {
				navLink.parentNode.classList.remove('nav-item-open');
			}
		});
	}

	var appHeight = function() {
		document.documentElement.style.setProperty('--app-height', window.innerHeight + 'px');
	}

	window.addEventListener('resize', appHeight);
	appHeight();

	function hasParentClass(child, className){
		try {
			if (child.className.split(' ').indexOf(className) >= 0) {
				return true;
			}
			
			return child.parentNode && hasParentClass(child.parentNode, className);
		} catch (TypeError) {
			return false;
		}
	}
})();
